import {v4 as uuidv4} from 'uuid'
import {Bookkeepable, TransactionEntryLinePartial} from '@/assignments/BookkeepingActionable/BookkeepingActionable.type'
import {TransactionEntryLine} from '@/types/transaction/TransactionEntryLine'
import {defaultVatOption} from '@/vat/types/VatOptions'
import {useTransactionCreator} from '@/transaction/create-transaction/TransactionCreator.service'
import {Assignment} from '@/assignments/Assignment.type'
import {assignmentToFulfillment} from '@/assignments/assignment.service'
import {DocumentMeta} from '@/types/transaction/DocumentMeta'
import {getDocumentMeta} from '@/services/infrastructure/storage.service'

const {transactionEntryLines, fulfillment, attachments} = useTransactionCreator()

const mapToEntries = (lines: TransactionEntryLinePartial[]): TransactionEntryLine[] => {

    return lines.map((line, lineIndex) => {
        const debitAccountNo = line.debitAccount === '2400' && !line.debitSubAccount ? undefined : line.debitAccount
        const creditAccountNo = line.creditAccount === '2400' && !line.creditSubAccount ? undefined : line.creditAccount
        const entry: TransactionEntryLine = {
            entryUuid: uuidv4(),
            subAccountLines: line.subAccountLines ?? [],
            tags: line.tags ?? [],
            debitAccount: debitAccountNo ?? undefined,
            debitSubAccount: line.debitSubAccount ?? undefined,
            vatOptionIdDebit: line.vatOptionIdDebit ?? defaultVatOption.id,
            creditAccount: creditAccountNo ?? undefined,
            creditSubAccount: line.creditSubAccount ?? undefined,
            vatOptionIdCredit: line.vatOptionIdCredit ?? defaultVatOption.id,
            date: line.date ? new Date(line.date): new Date(),
            description: line.description ?? '',
            amount: Math.abs(line.amount ?? 0),
            project: line.project ?? undefined,
            department: line.department ?? undefined,
            entryLineIndex: line.entryLineIndex ?? lineIndex,
            invoiceUuid: line.invoiceUuid ?? undefined,
            invoiceDueDate: line.invoiceDueDate ? new Date(line.invoiceDueDate) : undefined,
            invoiceNo: line.invoiceNo ?? undefined,
            bban: line.bban ?? undefined,
            kid: line.kid ?? undefined
        }
        return entry
    })
}

export const handleBookkeepingActionable = async (bookkeepable: Bookkeepable, assignment: Assignment) => {
    const entries = mapToEntries(bookkeepable.transactionEntryLines)
    if (entries.length > 0) {
        transactionEntryLines.value = mapToEntries(bookkeepable.transactionEntryLines)
    }
    fulfillment.value = assignmentToFulfillment(assignment)

    if (bookkeepable.documentMetaUuids?.length) {
        attachments.value = await Promise.all(
            bookkeepable.documentMetaUuids.map(uuid => getDocumentMeta(uuid))
        ) as DocumentMeta[]
    }
}

